import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const productsManifest: FeatureManifest = {
  id: 'catalog-products',
  path: 'catalogs/products/:productId?',
  navPath: '/catalogs/products',
  label: 'Biên soạn sản phẩm',
  requiredPermissions: ['catalogs'],
  navigationGroup: { id: 'catalogs', label: 'Quản lý danh mục' },
  load: () => import('./entry'),
}
